import CommonUtils from '@/shared/utils/commonUtils'

const Utils = {
  common: CommonUtils,
}
export default Utils
